import { AsYouType, parsePhoneNumberFromString, getCountries, getCountryCallingCode } from "libphonenumber-js";

const TZ_MAP = [
  [/^Pacific\/Auckland|^Pacific\/Chatham|^NZ/, "NZ"], [/^Australia\//, "AU"], [/^Europe\/London|^Europe\/Belfast/, "GB"], [/^Europe\/Dublin/, "IE"],
  [/^America\/(Toronto|Vancouver|Edmonton|Winnipeg|Halifax|St_Johns|Regina|Montreal)/, "CA"], [/^America\//, "US"], [/^Pacific\/Honolulu/, "US"],
  [/^Europe\/Paris/, "FR"], [/^Europe\/Berlin/, "DE"], [/^Europe\/Madrid/, "ES"], [/^Europe\/Rome/, "IT"], [/^Europe\/Lisbon/, "PT"], [/^Europe\/Amsterdam/, "NL"],
  [/^Asia\/Kolkata|^Asia\/Calcutta/, "IN"], [/^Asia\/Manila/, "PH"], [/^Asia\/Singapore/, "SG"], [/^Asia\/Tokyo/, "JP"], [/^Asia\/Shanghai|^Asia\/Hong_Kong/, "CN"], [/^Africa\/Johannesburg/, "ZA"], [/^Pacific\/Fiji/, "FJ"],
];
const COUNTRIES = new Set(getCountries());
const KEY = "dropit-phone-country";

export const regionFromE164 = (e164) => { try { return parsePhoneNumberFromString(e164 || "")?.country || null; } catch { return null; } };

export const defaultRegion = (profilePhone) => {
  const own = regionFromE164(profilePhone);
  if (own && COUNTRIES.has(own)) return own;
  const saved = localStorage.getItem(KEY);
  if (saved && COUNTRIES.has(saved)) return saved;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const hit = TZ_MAP.find(([re]) => re.test(tz));
    if (hit) return hit[1];
  } catch { /* none */ }
  const region = (navigator.language || "").split(/[-_]/)[1]?.toUpperCase();
  if (region && COUNTRIES.has(region)) return region;
  return "NZ";
};

export const rememberRegion = (r) => localStorage.setItem(KEY, r);

export const sanitize = (raw) => raw.replace(/[\s().-]/g, "").replace(/^00/, "+");

export const formatPhone = (raw, region) => {
  const clean = sanitize(raw);
  const parsed = parsePhoneNumberFromString(clean, clean.startsWith("+") ? undefined : region);
  return {
    display: new AsYouType(clean.startsWith("+") ? undefined : region).input(clean) || raw,
    e164: parsed?.isValid() ? parsed.number : "",
    valid: !!parsed?.isValid(),
    country: parsed?.country || null,
  };
};

const flag = (cc) => String.fromCodePoint(...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
const NAMES = typeof Intl !== "undefined" && Intl.DisplayNames ? new Intl.DisplayNames(["en"], { type: "region" }) : null;
export const COUNTRY_OPTIONS = getCountries().map((cc) => ({ cc, flag: flag(cc), dial: `+${getCountryCallingCode(cc)}`, name: NAMES?.of(cc) || cc })).sort((a, b) => a.name.localeCompare(b.name));

export const validEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
